import { uniqueId } from '../utils.js';
import { getErrorMessage } from "../../helpers/common.js";

export default {
  state: {
    loading: false,
    error: null,
    success: null,
    warning: null,
    messages: [],
    title: ''
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_TITLE(state, payload) {
      state.title = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    CLEAR_ERROR(state) {
      state.error = null
    },
    PUSH_ERROR(state, payload) {
      state.messages.push({
        id: uniqueId("item_"),
        color: 'error',
        message: getErrorMessage(payload)
      });
    },
    PUSH_WARNING(state, payload) {
      state.messages.push({
        id: uniqueId("item_"),
        color: 'warning',
        message: payload
      });
    },
    PUSH_ERROR_MESSAGE(state, payload) {
      state.messages.push({
        id: uniqueId("item_"),
        color: 'error',
        message: payload
      });
    },
    PUSH_SUCCESS(state, payload) {
      state.messages.push({
        id: uniqueId("item_"),
        color: 'success',
        message: payload
      });
    },
    DELETE_MESSAGE(state, payload) {
      const index = state.messages.findIndex(item => item.id === payload);

      if (index !== -1) {
        state.messages.splice(index, 1);
      }
    },
  },
  actions: {
    SET_LOADING(context, payload) {
      context.commit('SET_LOADING', payload);
    },
    SET_TITLE(context, payload) {
      context.commit('SET_TITLE', payload);
    },
    SET_ERROR(context, payload) {
      context.commit('SET_ERROR', payload);
    },
    CLEAR_ERROR(context) {
      context.commit('CLEAR_ERROR');
    },
    PUSH_ERROR(context, payload) {
      context.commit('PUSH_ERROR', payload);
    },
    PUSH_ERROR_MESSAGE(context, payload) {
      context.commit('PUSH_ERROR_MESSAGE', payload);
    },
    PUSH_SUCCESS(context, payload) {
      context.commit('PUSH_SUCCESS', payload);
    },
    PUSH_WARNING(context, payload) {
      context.commit('PUSH_WARNING', payload);
    },
    DELETE_MESSAGE(context, payload) {
      context.commit('DELETE_MESSAGE', payload);
    },

  },
  getters: {
    LOADING(state) {
      return state.loading
    },
    TITLE(state) {
      return state.title;
    },
    ERROR(state) {
      return state.error
    },
    MESSAGES(state) {
      return state.messages
    },
  }
}